import { render } from "./updateseatingtype.vue?vue&type=template&id=6a94ff5e"
import script from "./updateseatingtype.vue?vue&type=script&lang=js"
export * from "./updateseatingtype.vue?vue&type=script&lang=js"

import exportComponent from "/home/vsts/work/1/s/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__